"use client";

import React from "react";
import Button from "../ui/button";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  PinterestShareButton,
  FacebookIcon,
  LinkedinIcon,
  XIcon,
  PinterestIcon,
} from "react-share";
import { usePathname, useRouter } from "next/navigation";
import BottomCurves from "../curves/bottomCurves";
import { ShareIcon } from "@heroicons/react/24/outline";

interface EditorProps {
  data: {
    editor: string;
  };
  path?: string;
}

export default function Editor({ data, path }: EditorProps) {
  const pathname = usePathname();
  const router = useRouter();
  const shareUrl = process.env.NEXT_PUBLIC_URL + pathname;

  const ShareButtons = ({ shareUrl }: any) => (
    <div className="relative">
      <div className="group relative pb-4 md:hidden">
        <button
          type="button"
          className="flex items-center gap-2 absolute top-0 opacity-100 rounded-full px-6 py-2.5 font-semibold bg-purple text-white shadow-sm ring-1 ring-inset ring-purple duration-150 delay-75"
          onClick={async () => {
            const shareData = {
              title: "Kingdom Digital Sdn Bhd",
              text: "Check out this Kingdom Digital post!",
              url: shareUrl,
            };
            try {
              await navigator.share(shareData);
            } catch (err) {
              console.log(err);
            }
          }}
        >
          <ShareIcon className="p-0 w-4 h-4" />
          Share
        </button>
      </div>
      <div className="group relative pb-4 max-md:hidden">
        <button
          type="button"
          className="flex items-center gap-2 absolute top-0 opacity-100 rounded-full px-6 py-2.5 font-semibold bg-purple text-white shadow-sm ring-1 ring-inset ring-purple group-hover:opacity-0 transition-opacity duration-150 delay-75"
        >
          <ShareIcon className="p-0 w-4 h-4" />
          Share
        </button>
        <div className="absolute top-0 flex opacity-0 group-hover:opacity-100 items-center space-x-2 py-0.5 transition-opacity duration-150 delay-75">
          <FacebookShareButton url={shareUrl}>
            <FacebookIcon
              size={40}
              round={true}
              bgStyle={{ background: "transparent" }}
            />
          </FacebookShareButton>
          <TwitterShareButton url={shareUrl}>
            <XIcon
              size={40}
              round={true}
              bgStyle={{ background: "transparent" }}
            />
          </TwitterShareButton>
          <LinkedinShareButton url={shareUrl}>
            <LinkedinIcon
              size={40}
              round={true}
              bgStyle={{ background: "transparent" }}
            />
          </LinkedinShareButton>
          <PinterestShareButton media={shareUrl} url={shareUrl}>
            <PinterestIcon
              size={40}
              round={true}
              bgStyle={{ background: "transparent" }}
            />
          </PinterestShareButton>
        </div>
      </div>
    </div>
  );

  return (
    <section className="bg-midGrey pb-32 md:pb-[12.333vw] pt-[5.333vw] px-[30px] md:px-[17.188vw]">
      {path === "news/beware-of-job-scams" && (
        <></>
      )}
      <div
        dangerouslySetInnerHTML={{
          __html: data.editor,
        }}
        className="editor bg-midGrey mt-12"
      ></div>

      {path &&
        (path.includes("beware-of-job-scams") || path === "/privacy") ? (
        <>
          <div className="flex gap-4">
            <Button text="Back" link="/" className="" />
            <ShareButtons shareUrl={shareUrl} />
          </div>
          <BottomCurves color="dark purple" direction="left" />
        </>
      ) : path?.includes("news") ? (
        <>
          <div className="flex gap-4">
            <Button text="Back" link="/news" className="" />
            <ShareButtons shareUrl={shareUrl} />
          </div>
          <BottomCurves
            color="rainbow purple to blue"
            direction="left"
          />
        </>
      ) : path?.includes("career") ? (
        <div className="flex items-center gap-x-3" data-lenis-prevent>
          <Button
            text="Apply Now"
            onClick={() => {
              return;
            }}
            className="mt-8 careerFormButton"
          />
          <Button text="Back" link="/careers" className="mt-8" />
          <BottomCurves color="dark purple" direction="left" />
        </div>
      ) : null}
    </section>
  );
}
